import { z } from 'zod';
import { i18n } from '../../../locales';

export const MAX_CONTENT_LENGTH = 3000;

export const createProfileQuestionFormSchema = z.object({
	content: z.string()
		.min(3, i18n.t('profile.form.content.minLength'))
		.max(
			MAX_CONTENT_LENGTH,
			i18n.t('profile.form.content.maxLength', { maxLength: MAX_CONTENT_LENGTH }),
		),
});

export type CreateProfileQuestionFormInput = z.infer<typeof createProfileQuestionFormSchema>;

export const createProfileQuestionFormInitialValues: CreateProfileQuestionFormInput = {
	content: '',
};
